import { Input } from "@/components/ui/input";
import { Slider } from "@/components/ui/slider";
import { Label } from "@/components/ui/label";
import { formatCurrency } from "@/lib/portfolioCalculations";
import { AssetAllocationProps } from "@/types/portfolio";

const AssetAllocationControls = ({
  assetClass,
  portfolioSize,
  onChange,
  onInputChange,
  onInputBlur,
}: AssetAllocationProps) => {
  return (
    <div className="space-y-2">
      <div className="flex items-center justify-between">
        <Label className="text-sm font-medium">
          <div className="flex items-center gap-2">
            <div 
              className="w-3 h-3 rounded-sm" 
              style={{ backgroundColor: assetClass.color }} 
            />
            {assetClass.name}
          </div>
        </Label>
        <div className="text-sm text-muted-foreground">
          {formatCurrency(portfolioSize * (assetClass.value / 100))}
        </div>
      </div>
      
      <div className="flex gap-4">
        <Slider
          value={[assetClass.value]}
          min={0}
          max={100}
          step={1}
          onValueChange={(values) => onChange(values[0])}
          className="flex-1"
        />
        <div className="relative w-20">
          <Input
            type="text"
            value={assetClass.value.toString()}
            onChange={(e) => onInputChange(e.target.value)}
            onBlur={onInputBlur}
            className="pr-6"
          />
          <span className="absolute right-2 top-1/2 -translate-y-1/2 text-sm text-muted-foreground">
            %
          </span>
        </div>
      </div>
    </div>
  );
};

export default AssetAllocationControls;